import { render, staticRenderFns } from "./SimilarTitlesGraphql.vue?vue&type=template&id=4bb25cda&scoped=true&"
import script from "./SimilarTitlesGraphql.vue?vue&type=script&lang=ts&"
export * from "./SimilarTitlesGraphql.vue?vue&type=script&lang=ts&"
import style0 from "./SimilarTitlesGraphql.vue?vue&type=style&index=0&id=4bb25cda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb25cda",
  null
  
)

export default component.exports